/* OBS product page: gallery, variant picker, sticky CTA, dialogs and the COD order form. */
(() => {
  const root = document.querySelector('[data-obs-pdp]');
  if (!root) return;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => [...r.querySelectorAll(s)];
  const data = JSON.parse($('[data-obs-product]').textContent);
  const form = document.getElementById('obs-order');
  // The `t` filter HTML-escapes translations (an apostrophe arrives as &#39;); decode once for textContent use.
  const decode = (str) => { const t = document.createElement('textarea'); t.innerHTML = str; return t.value; };
  const T = Object.fromEntries(Object.entries(JSON.parse(document.querySelector('[data-obs-i18n]').textContent)).map(([k, v]) => [k, typeof v === 'string' ? decode(v) : v]));
  const fmt = (cents) => (Math.round(cents / 100)).toLocaleString('fr-FR').replace(/[\s\u00a0\u202f]/g, '\u202f') + '\u00a0' + T.money_suffix;
  const emit = (name, detail) => document.dispatchEvent(new CustomEvent('obs:' + name, { detail }));

  /* ---------- gallery: one slider, filtered to the selected colour ---------- */
  const track = $('[data-obs-track]');
  const idx = $('[data-obs-idx]');
  const total = $('[data-obs-total]');
  const slides = $$('.obs-gal__slide');
  const thumbs = $$('.obs-gal__thumb');
  const visible = () => slides.filter((s) => !s.hidden);
  let current = 0;
  const go = (i, smooth = true) => {
    const v = visible(); if (!v.length) return;
    current = (i + v.length) % v.length;
    // On-screen positions instead of offsetLeft: correct in RTL, where scrollLeft runs negative.
    track.scrollBy({ left: v[current].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: smooth ? 'smooth' : 'auto' });
    sync();
  };
  const sync = () => {
    const v = visible();
    if (idx) idx.textContent = Math.min(current + 1, v.length);
    if (total) total.textContent = v.length;
    root.querySelector('.obs-gal').classList.toggle('is-single', v.length < 2);
    thumbs.forEach((t) => t.classList.toggle('is-on', v[current] && t.dataset.mediaId === v[current].dataset.mediaId));
  };
  // keep the counter honest when the customer swipes
  let raf = 0;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const v = visible(); const w = track.clientWidth || 1;
      const left = track.getBoundingClientRect().left;
      const i = v.findIndex((s) => Math.abs(s.getBoundingClientRect().left - left) < w / 2);
      if (i > -1 && i !== current) { current = i; sync(); }
    });
  }, { passive: true });
  $$('[data-obs-nav]').forEach((b) => b.addEventListener('click', () => go(current + Number(b.dataset.obsNav))));
  thumbs.forEach((t) => t.addEventListener('click', () => go(visible().findIndex((s) => s.dataset.mediaId === t.dataset.mediaId))));
  const filterColor = (color) => {
    if (!color || !slides.some((s) => s.dataset.color === color)) return; // no studio set for this colour: keep all
    slides.forEach((s) => { s.hidden = s.dataset.color !== color; });
    thumbs.forEach((t) => { t.hidden = t.dataset.color !== color; });
    go(0, false);
  };
  const showMedia = (mediaId) => {
    const i = visible().findIndex((s) => s.dataset.mediaId == mediaId);
    if (i > -1) go(i);
  };
  sync();

  /* ---------- dialogs ---------- */
  const zoomDlg = document.getElementById('obs-zoom');
  const zoomBox = zoomDlg.querySelector('[data-obs-zoom-box]');
  $$('[data-obs-zoom]').forEach((b) => b.addEventListener('click', () => {
    zoomBox.innerHTML = '';
    const img = new Image(); img.alt = ''; img.src = b.dataset.obsZoom; // created on demand: no empty <img> in the page
    zoomBox.appendChild(img);
    zoomDlg.showModal();
  }));
  $$('[data-obs-open]').forEach((b) => b.addEventListener('click', () => document.getElementById(b.dataset.obsOpen).showModal()));
  $$('dialog').forEach((d) => {
    d.addEventListener('click', (e) => { if (e.target === d || e.target.closest('[data-obs-close]')) d.close(); });
  });

  /* ---------- variants ---------- */
  const optionSets = $$('[data-obs-option]');
  const selected = () => optionSets.map((fs) => (fs.querySelector('input:checked') || {}).value || null);
  let variant = null;
  const findVariant = (sel) => data.variants.find((v) => v.options.every((o, i) => sel[i] === o)) || null;
  const updateAvailability = (sel) => {
    // Grey out sizes that are unavailable for the chosen colour.
    if (data.sizeIndex === null) return;
    const fs = optionSets[data.sizeIndex];
    $$('input', fs).forEach((inp) => {
      const probe = sel.slice(); probe[data.sizeIndex] = inp.value;
      const v = data.variants.find((x) => x.options.every((o, i) => probe[i] === null || probe[i] === o));
      inp.closest('.obs-chip').classList.toggle('is-out', !v || !v.available);
    });
  };
  const sizeErr = $('[data-obs-size-err]');
  const onOptionChange = (e) => {
    const sel = selected();
    optionSets.forEach((fs, i) => { const b = $('[data-obs-optval]', fs); if (sel[i]) b.textContent = sel[i]; });
    if (sizeErr) sizeErr.textContent = '';
    variant = findVariant(sel);
    updateAvailability(sel);
    // colour change → jump gallery to that colour's photo
    if (data.colorIndex !== null) {
      const color = sel[data.colorIndex];
      if (e && e.target.name === 'opt' + (data.colorIndex + 1)) filterColor(color);
      // keep the order-summary thumbnail on the chosen colour
      const first = slides.find((s) => s.dataset.color === color) || slides[0];
      const img = first && first.querySelector('img');
      const thumb = document.querySelector('.obs-sum__img');
      if (img && thumb) { thumb.srcset = ''; thumb.src = img.currentSrc || img.src; }
    }
    const priceV = variant || data.variants.find((v) => data.colorIndex === null || v.options[data.colorIndex] === sel[data.colorIndex]) || data.variants[0];
    $$('[data-obs-price]', document).forEach((el) => { el.textContent = fmt(priceV.price); });
    if (variant) {
      const url = new URL(location.href); url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
      emit('variant', { id: variant.id, title: variant.title });
    }
    cod.refresh();
  };
  optionSets.forEach((fs) => fs.addEventListener('change', onOptionChange));

  /* ---------- sticky CTA (mobile) ---------- */
  const sticky = $('[data-obs-sticky]');
  const stickyBtn = $('[data-obs-goto-form]');
  let formVisible = false, pastTop = false;
  const syncSticky = () => {
    const on = pastTop && !formVisible && !form.hidden;
    sticky.classList.toggle('is-on', on);
    sticky.setAttribute('aria-hidden', String(!on));
    stickyBtn.tabIndex = on ? 0 : -1;
  };
  new IntersectionObserver(([e]) => { formVisible = e.isIntersecting; syncSticky(); }).observe(form);
  new IntersectionObserver(([e]) => { pastTop = !e.isIntersecting; syncSticky(); }).observe($('.obs-info__price'));
  stickyBtn.addEventListener('click', () => {
    const needSize = data.sizeIndex !== null && !selected()[data.sizeIndex];
    const target = needSize ? optionSets[data.sizeIndex] : form;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (needSize && sizeErr) sizeErr.textContent = T.err_size;
    else setTimeout(() => { const f = [...form.querySelectorAll('input.obs-input, select.obs-input')].find((x) => !x.value && !x.disabled); (f || form.elements.name).focus({ preventScroll: true }); }, 450);
  });

  /* ---------- COD form ---------- */
  const cod = (() => {
    const el = (n) => form.elements[n];
    const wil = el('wilaya'), com = el('commune');
    const max = parseInt(form.dataset.max, 10) || 5;
    let qty = 1, geo = null, started = false;
    const openedAt = Date.now();
    const isAr = document.documentElement.lang.startsWith('ar');
    const deskUnavailable = (w) => Boolean(w && w.h != null && w.d == null);
    const fee = () => {
      const w = geo && geo.w.find((x) => String(x.c) === wil.value);
      if (!w || w.h == null) return null;
      const v = form.mode.value === 'desk' ? w.d : w.h;
      return v == null ? null : v * 100;                 // no office in this wilaya: never a 0 DA fee
    };
    const load = () => geo ? Promise.resolve(geo) : fetch(form.dataset.src).then((r) => r.json()).then((j) => {
      geo = j;
      const frag = document.createDocumentFragment();
      j.w.forEach((w) => {
        const o = document.createElement('option');
        o.value = w.c;
        o.textContent = String(w.c).padStart(2, '0') + ' · ' + (isAr ? w.ar : w.fr) + (w.h == null ? ' — ' + T.unavailable : '');
        o.disabled = w.h == null;
        frag.appendChild(o);
      });
      wil.appendChild(frag);
      return j;
    });
    // Load the wilaya list as soon as the form approaches the viewport.
    new IntersectionObserver(([e], obs) => { if (e.isIntersecting) { load(); obs.disconnect(); } }, { rootMargin: '400px' }).observe(form);

    const fillCommunes = () => {
      const w = geo && geo.w.find((x) => String(x.c) === wil.value);
      com.length = 1;
      com.disabled = !w;
      if (!w) return;
      const frag = document.createDocumentFragment();
      w.m.forEach(([fr, ar, newCode]) => {
        const o = document.createElement('option');
        o.value = fr; o.textContent = isAr ? ar + ' · ' + fr : fr + ' · ' + ar;
        o.dataset.w69 = newCode;
        frag.appendChild(o);
      });
      com.appendChild(frag);
    };
    const refresh = () => {
      const w = geo && geo.w.find((x) => String(x.c) === wil.value);
      // Wilaya served at home but without a delivery office (ZR has none there): the office option cannot be chosen.
      // An office choice made before is NOT switched silently: it stays, with a message asking for home delivery, and
      // the order cannot be sent until the customer chooses home delivery herself.
      const deskOpt = form.querySelector('input[name="mode"][value="desk"]');
      const noDesk = deskUnavailable(w);
      deskOpt.disabled = noDesk && !deskOpt.checked;
      deskOpt.closest('label')?.classList.toggle('is-disabled', noDesk);
      setErr('mode', noDesk && deskOpt.checked ? T.err_desk_unavailable : '');
      form.querySelector('[data-fee="home"]').textContent = w && w.h != null ? fmt(w.h * 100) : T.from_home;
      form.querySelector('[data-fee="desk"]').textContent = noDesk ? T.unavailable : w && w.d != null ? fmt(w.d * 100) : T.from_desk;
      form.querySelector('[data-obs-address]').hidden = form.mode.value === 'desk';
      const sel = selected();
      const base = variant || data.variants.find((v) => data.colorIndex === null || v.options[data.colorIndex] === sel[data.colorIndex]) || data.variants[0];
      const sub = base.price * qty;
      const f = fee();
      form.querySelector('[data-obs-sub]').textContent = fmt(sub);
      form.querySelector('[data-obs-ship]').textContent = f == null ? (noDesk && deskOpt.checked ? T.unavailable : T.choose_wilaya) : fmt(f);
      form.querySelector('[data-obs-total]').textContent = f == null ? '—' : fmt(sub + f);
      form.querySelector('[data-obs-sumvar]').textContent = variant ? variant.title + (qty > 1 ? ' · ×' + qty : '') : T.choose_size_first;
      form.querySelector('[data-obs-qtyval]').textContent = qty;
    };
    wil.addEventListener('focus', load);
    wil.addEventListener('change', () => { fillCommunes(); setErr('wilaya', ''); refresh(); });
    com.addEventListener('change', () => setErr('commune', ''));
    form.addEventListener('change', (e) => { if (e.target.name === 'mode') refresh(); });
    form.addEventListener('focusin', () => { if (!started) { started = true; emit('form_start', { product: data.id }); } });
    form.querySelectorAll('[data-obs-qty]').forEach((b) => b.addEventListener('click', () => {
      qty = Math.min(max, Math.max(1, qty + parseInt(b.dataset.obsQty, 10))); refresh();
    }));

    const setErr = (name, msg) => {
      const out = root.querySelector('[data-err="' + name + '"]');
      if (out) out.textContent = msg;
      const field = el(name);
      if (field && field.setAttribute) field.setAttribute('aria-invalid', msg ? 'true' : 'false');
    };
    const normPhone = (v) => {
      const d = v.replace(/[\s.\-()]/g, '');
      const m = d.match(/^(?:\+?213|00213|0)([567]\d{8})$/);
      return m ? '+213' + m[1] : null;
    };
    el('phone').addEventListener('blur', () => { if (el('phone').value) setErr('phone', normPhone(el('phone').value) ? '' : T.err_phone); });
    el('name').addEventListener('blur', () => { if (el('name').value) setErr('name', el('name').value.trim().length >= 3 ? '' : T.err_name); });

    const cookie = (n) => (document.cookie.match('(?:^|; )' + n + '=([^;]*)') || [])[1] || '';
    // Campaign parameters: this URL's, else the session's landing page (kept by obs.js).
    const utmParams = () => {
      const pick = (q) => Object.fromEntries([...new URLSearchParams(q)].filter(([k]) => /^utm_|^fbclid$/.test(k)));
      const here = pick(location.search);
      if (Object.keys(here).length) return here;
      try { return JSON.parse(sessionStorage.getItem('obs_utm') || '{}'); } catch (e) { return {}; }
    };
    const fbcFromUrl = () => { const id = new URLSearchParams(location.search).get('fbclid'); return id ? 'fb.1.' + Date.now() + '.' + id : ''; };
    const FIELD = { invalid_name: 'name', invalid_phone: 'phone', invalid_wilaya: 'wilaya', invalid_commune: 'commune', not_delivered: 'wilaya', desk_unavailable: 'mode' };
    // Bring the size picker into view: its message sits far above the submit button on phones.
    const showSize = (msg) => {
      if (sizeErr) sizeErr.textContent = msg;
      const set = data.sizeIndex !== null && optionSets[data.sizeIndex];
      if (set) { set.scrollIntoView({ behavior: 'smooth', block: 'center' }); const i = set.querySelector('input'); if (i) i.focus({ preventScroll: true }); }
    };
    const review = root.querySelector('[data-obs-review]');
    // Server answers -> the field or message the customer can act on. Field problems go back to the form.
    const serverError = (status, body, where = 'form') => {
      const toForm = () => { if (!review.hidden) { review.hidden = true; form.hidden = false; syncSticky(); } };
      if (status === 422 && body.fields) {
        toForm();
        let focus = null;
        Object.entries(body.fields).forEach(([f, code]) => {
          const name = FIELD[code] || f;
          const msg = code === 'not_delivered' ? T.err_not_delivered : code === 'desk_unavailable' ? T.err_desk_unavailable : T['err_' + name] || T.err_network;
          if (name === 'size' || name === 'quantity') showSize(code === 'insufficient_stock' ? T.err_stock : code === 'sold_out' ? T.err_sold : T.err_size);
          else { setErr(name, msg); focus = focus || el(name); }
        });
        if (focus) focus.focus();
        return;
      }
      if (status === 409 && (body.error === 'sold_out' || body.error === 'insufficient_stock')) { toForm(); return showSize(body.error === 'sold_out' ? T.err_sold : T.err_stock); }
      const out = root.querySelector('[data-err="' + where + '"]');
      delete out.dataset.tone;
      if (status === 409) return setErr(where, T.err_in_progress);
      if (status === 202) { setErr(where, T.err_pending); out.dataset.tone = 'info'; return; }
      if (status === 429) return setErr(where, T.err_too_many);
      // 5xx at the CONFIRMATION step: Shopify's app proxy can time out (504) while the order is being created, so
      // "nothing was recorded" may be false. Say it may exist and that pressing again is safe (same key: replayed or
      // looked up, never a second order). At the review step no order can exist: the service is just unavailable.
      if (status >= 500 && where === 'review') { setErr(where, T.err_uncertain || T.err_pending); out.dataset.tone = 'info'; return; }
      if (status >= 500) return setErr(where, T.err_unavailable || T.err_network);
      setErr(where, T.err_network);
    };
    const post = async (url, payload) => {
      const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout ? AbortSignal.timeout(20000) : undefined });
      return { status: res.status, ok: res.ok, body: await res.json().catch(() => ({})) };
    };
    const busyBtn = (btn, on, label) => {
      btn.disabled = on; btn.classList.toggle('is-busy', on);
      const l = btn.querySelector('span'); l.dataset.label = l.dataset.label || l.textContent;
      l.textContent = on ? label : l.dataset.label;
    };
    let busy = false;
    const key = () => (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random());
    let idem = key();
    let pending = null; // { payload, w } between the review and the confirmation
    const endpoint = form.dataset.endpoint;
    const preview = form.dataset.preview === 'true';
    const off = form.dataset.off === 'true';   // no order endpoint on the live storefront: say so, never fake a confirmation

    // Step 1 — check the form, ask the server for its prices, show the review.
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (busy) return;
      if (off) { setErr('form', T.err_off); return; }
      let first = null;
      const fail = (name, msg, focusEl) => { setErr(name, msg); if (msg && !first) first = focusEl || el(name); };
      const sel = selected();
      if (data.sizeIndex !== null && !sel[data.sizeIndex]) {
        if (sizeErr) sizeErr.textContent = T.err_size;
        first = first || optionSets[data.sizeIndex].querySelector('input');
      } else if (variant && !variant.available) {
        if (sizeErr) sizeErr.textContent = T.err_sold;
        first = first || optionSets[data.sizeIndex].querySelector('input');
      }
      fail('name', el('name').value.trim().length >= 3 ? '' : T.err_name);
      const phone = normPhone(el('phone').value);
      fail('phone', phone ? '' : T.err_phone);
      fail('wilaya', wil.value ? '' : T.err_wilaya);
      fail('commune', com.value ? '' : T.err_commune);
      const wSel = geo && geo.w.find((x) => String(x.c) === wil.value);
      fail('mode', form.mode.value === 'desk' && deskUnavailable(wSel) ? T.err_desk_unavailable : '', form.querySelector('input[name="mode"][value="home"]'));
      if (first) { first.focus(); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (el('website').value) return; // honeypot

      busy = true;
      const btn = form.querySelector('[data-obs-submit]');
      busyBtn(btn, true, T.checking);
      setErr('form', '');
      const w = geo.w.find((x) => String(x.c) === wil.value);
      const payload = {
        idempotency_key: idem, variant_id: variant.id, quantity: qty,
        name: el('name').value.trim(), phone, wilaya_code: w.c,
        wilaya_69: (com.selectedOptions[0] || {}).dataset ? Number(com.selectedOptions[0].dataset.w69) : null,
        commune: com.value, mode: form.mode.value, address: el('address').value.trim(), note: el('note').value.trim(),
        page: location.pathname, utm: utmParams(),
        elapsed_ms: Date.now() - openedAt, website: el('website').value,
        fbp: cookie('_fbp'), fbc: cookie('_fbc') || fbcFromUrl(),
        // false only when Shopify's privacy API says marketing was refused; the server then skips its Meta Lead.
        marketing_consent: (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.marketingAllowed === 'function')
          ? Shopify.customerPrivacy.marketingAllowed() !== false : null
      };
      try {
        let quote;
        if (preview) quote = { subtotal: variant.price * qty / 100, delivery: fee() / 100, total: (variant.price * qty + fee()) / 100 };
        else {
          const r = await post(endpoint.replace(/\/order$/, '/quote'), payload);
          if (!r.ok || !r.body.ok) return serverError(r.status, r.body);
          quote = r.body; // the server's prices, not the page's
        }
        pending = { payload, w };
        showReview(quote, payload, w);
      } catch (err) {
        setErr('form', T.err_network);
      } finally {
        busy = false; busyBtn(btn, false);
      }
    });

    const money = (da) => fmt(Math.round(da) * 100);
    const communeName = (p, w) => { const m = w.m.find((x) => x[0] === p.commune); return isAr && m ? m[1] : p.commune; };
    const deliveryLine = (p, w) => (p.mode === 'desk' ? T.desk : T.home) + ' · ' + communeName(p, w) + (isAr ? '، ' : ', ') + (isAr ? w.ar : w.fr);
    const fillList = (list, rows) => {
      list.innerHTML = rows.map(() => '<div><dt></dt><dd></dd></div>').join('');
      list.querySelectorAll('div').forEach((d, i) => { d.querySelector('dt').textContent = rows[i][0]; d.querySelector('dd').textContent = rows[i][1]; });
    };
    const showReview = (q, p, w) => {
      fillList(review.querySelector('[data-obs-review-list]'), [
        [T.l_product, data.title + ' · ' + variant.title + ' · ×' + p.quantity],
        [T.l_name, p.name],
        [T.l_phone, p.phone.replace('+213', '0')],
        [T.l_mode, deliveryLine(p, w)],
        ...(p.mode === 'home' && p.address ? [[T.l_address, p.address]] : []),
        ...(p.note ? [[T.l_note, p.note]] : []),
        [T.l_subtotal, money(q.subtotal)],
        [T.l_fee, money(q.delivery)],
        [T.l_total, money(q.total)]
      ]);
      review.querySelector('[data-obs-review-list] div:last-child').classList.add('is-total');
      setErr('review', '');
      form.hidden = true; review.hidden = false; syncSticky();
      emit('review', { value: q.total, currency: form.dataset.currency });
      review.focus({ preventScroll: true }); review.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    review.querySelector('[data-obs-edit]').addEventListener('click', () => {
      review.hidden = true; form.hidden = false; syncSticky();
      form.scrollIntoView({ block: 'center' }); el('name').focus({ preventScroll: true });
    });

    // Step 2 — the customer confirms: only now is the order sent.
    review.querySelector('[data-obs-confirm]').addEventListener('click', async () => {
      if (busy || !pending) return;
      busy = true;
      const btn = review.querySelector('[data-obs-confirm]');
      busyBtn(btn, true, T.sending);
      setErr('review', '');
      const { payload, w } = pending;
      payload.elapsed_ms = Date.now() - openedAt;
      try {
        let result;
        if (preview) {
          // PREVIEW MODE — nothing leaves the browser.
          await new Promise((r) => setTimeout(r, 900));
          result = { order_name: 'APERÇU', subtotal: variant.price * qty / 100, delivery: fee() / 100, total: (variant.price * qty + fee()) / 100 };
        } else {
          const r = await post(endpoint, payload);
          if (!r.ok || !r.body.ok || !r.body.order_name) return serverError(r.status, r.body, 'review');
          result = r.body; // success is shown ONLY after the server confirms an order, with the server's totals
        }
        if (!preview) emit('lead', { event_id: payload.idempotency_key, value: result.total, currency: form.dataset.currency, content_ids: [String(variant.id)], num_items: payload.quantity });
        showDone(result, payload, w);
        idem = key(); pending = null;
      } catch (err) {
        // Timeout or lost connection: the order may or may not exist. The key is kept, so pressing the button again
        // cannot create a second order: say exactly that.
        setErr('review', T.err_uncertain || T.err_network);
        const out = root.querySelector('[data-err="review"]');
        if (out && T.err_uncertain) out.dataset.tone = 'info';
      } finally {
        busy = false; busyBtn(btn, false);
      }
    });

    const done = root.querySelector('[data-obs-done]');
    const showDone = (r, p, w) => {
      done.querySelector('[data-obs-done-txt]').textContent = T.done_txt.replace('{{ phone }}', p.phone.replace('+213', '0'));
      fillList(done.querySelector('[data-obs-done-list]'), [
        [T.l_ref, r.order_name],
        [T.l_product, data.title + ' · ' + variant.title + ' · ×' + p.quantity],
        [T.l_delivery, deliveryLine(p, w) + ' · ' + money(r.delivery)],
        [T.l_total, money(r.total)]
      ]);
      done.querySelector('[data-obs-done-list] div:last-child').classList.add('is-total');
      review.hidden = true; form.hidden = true; done.hidden = false; syncSticky();
      done.focus(); done.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    done.querySelector('[data-obs-again]').addEventListener('click', () => { done.hidden = true; form.hidden = false; form.scrollIntoView({ block: 'center' }); });

    return { refresh };
  })();

  onOptionChange();
  emit('view', { product: data.id });
})();
